import { render } from "./P071.vue?vue&type=template&id=92495448&scoped=true"
import script from "./P071.vue?vue&type=script&lang=js"
export * from "./P071.vue?vue&type=script&lang=js"

import "./P071.vue?vue&type=style&index=0&id=92495448&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92495448"]])

export default __exports__